import { useNavigate } from "react-router-dom";
import { useAndyNotifications } from "@/features/notifications/viewModal/useAndyNotifications";
import { routes } from "@/app/navigation/routes";
import styles from "./NotificationsPage.module.css";

export const NotificationsPage = () => {
  const navigate = useNavigate();
  const { unreadCount: andyUnreadCount } = useAndyNotifications("notification");
  const { unreadCount: chatUnreadCount } = useAndyNotifications("chat");

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Notifications</h1>
      </header>

      <section className={styles.list} aria-label="Notification categories">
        <button
          type="button"
          className={styles.drawer}
          onClick={() => navigate(routes.andyNotifications)}
        >
          <span className={styles.icon} aria-hidden="true">
            🔔
          </span>
          <span className={styles.label}>The Andy App updates on your account</span>
          {andyUnreadCount > 0 && <span className={styles.unreadBadge}>{andyUnreadCount}</span>}
          <span className={styles.nextIcon} aria-hidden="true">
            ›
          </span>
        </button>

        <button
          type="button"
          className={styles.drawer}
          onClick={() => navigate(routes.chatNotifications)}
        >
          <span className={styles.icon} aria-hidden="true">
            💬
          </span>
          <span className={styles.label}>We&apos;re missing something</span>
          {chatUnreadCount > 0 && <span className={styles.unreadBadge}>{chatUnreadCount}</span>}
          <span className={styles.nextIcon} aria-hidden="true">
            ›
          </span>
        </button>
      </section>
    </main>
  );
};
